var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwipeLeftChevron(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "117px",
    height: "118px",
    viewBox: "0 0 117 118",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D2B5288B-0619-40BD-BF3A-92444317A153") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zenvoya-JULY-2024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HOTEL-DETAILS-1",
    transform: "translate(-10.000000, -687.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "swipe-left-chevron",
    transform: "translate(68.500000, 746.000000) scale(-1, 1) translate(-68.500000, -746.000000) translate(10.000000, 687.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.5,0.5 L116.5,117.5 L12,117.5 C8.82436269,117.5 5.94936269,116.212819 3.86827202,114.131728 C1.78718134,112.050637 0.5,109.175637 0.5,106 L0.5,12 C0.5,8.82436269 1.78718134,5.94936269 3.86827202,3.86827202 C5.94936269,1.78718134 8.82436269,0.5 12,0.5 L116.5,0.5 Z",
    id: "Rectangle",
    stroke: "none",
    fillOpacity: 0,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "arrow-right-s-line",
    transform: "translate(49.000000, 33.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "19.7273887 25.5001603 0 5.66667112 5.63638538 0 31 25.5001603 5.63638538 51 0 45.333369"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwipeLeftChevron);
export default __webpack_public_path__ + "static/media/swipe-left-chevron.1769ee373878ec3b208a1ce9e7f6f4db.svg";
export { ForwardRef as ReactComponent };